export var LocationStatus;
(function (LocationStatus) {
    LocationStatus["Active"] = "ACTIVE";
    LocationStatus["Archived"] = "ARCHIVED";
    LocationStatus["Historical"] = "HISTORICAL";
})(LocationStatus || (LocationStatus = {}));
